import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './modules/home/dashboard/dashboard.component';
import { RideHistoryComponent } from './modules/ride-history/ride-history.component';
import { RideDetailsComponent } from './modules/ride-history/ride-details/ride-details.component';
import { PageNotFoundComponent } from './core/page-not-found/page-not-found.component';
import { RouteDetailsComponent } from './modules/ride-history/ride-details/route-details/route-details.component';
import { AuthGuard } from './guard/auth.guard';
import { RoleGuard } from './guard/role.guard';
import { VantaFogLoginComponent } from './modules/logins/vanta fog login/vanta-fog-login.component';
import { VantaCloudLoginComponent } from './modules/logins/vanta cloud login/vanta-cloud-login.component';
import { HeatmapComponent } from './modules/statistics/heatmap/heatmap.component';
import { StatisticsComponent } from './modules/statistics/statistics.component';
import { RidingStatisticsComponent } from './modules/statistics/riding-statistics/riding-statistics.component';

/**
 * Definicija ruta za Angular aplikaciju e-bikeGPStracking.
 * Svaka ruta povezuje URL putanju s odgovarajućom komponentom.
 * 
 * - '' (prazna putanja): preusmjerava na '/login'
 * - 'login': prikazuje LoginComponent (stranica za prijavu)
 * - 'home': prikazuje DashboardComponent (glavna nadzorna ploča)
 * - 'ride-history': prikazuje RideHistoryComponent (povijest vožnji)
 * - 'ride-details/:rideId': prikazuje RideDetailsComponent (detalji vožnje prema ID-u)
 * - 'route-details/:routeId': prikazuje RouteDetailsComponent (detalji rute prema ID-u)
 * - '**': prikazuje PageNotFoundComponent za sve nepostojeće rute (404)
 */
export const routes: Routes = [
    { path: '', redirectTo:'/login' , pathMatch: 'full' },
    { path: 'login', title:'Mapsy', component: VantaFogLoginComponent },
    { path: 'home', title:'Home', component: DashboardComponent, canActivate: [AuthGuard] },
    { path: 'ride-history', title: 'Ride history', component: RideHistoryComponent, canActivate: [AuthGuard] },
    { path: 'ride-details/:rideId', title: 'Ride details', component: RideDetailsComponent, canActivate: [AuthGuard] },
    { path: 'route-details/:routeId', title: 'Route details', component: RouteDetailsComponent, canActivate: [AuthGuard] },
    {
    path: 'statistics',
    title: 'Statistics',
    component: StatisticsComponent,
    canActivate: [AuthGuard],
    children: [
        { path: '', redirectTo: 'heatmap', pathMatch: 'full' },
        { path: 'heatmap', title: 'Heatmap', component: HeatmapComponent },
        { path: 'riding-statistics', title: 'Riding Statistics', component: RidingStatisticsComponent }
    ]
},
    

    
    // Example admin-only route (uses RoleGuard). Replace component with admin area when available.
    { path: 'admin', title: 'Admin', component: DashboardComponent, canActivate: [AuthGuard, RoleGuard], data: { roles: ['ROLE_ADMIN'] } },

    // Test-only routes: visit /test-zona/XYZ to view the Test components
    { path: 'test-zona/cloudLogin', title: 'Cloud login', component: VantaCloudLoginComponent },

    // OVO MORA BITI ZADNJE!!!! Angular kada traži stranicu onda ide po redu, ako ne nađe odabranu rutu onda će prikazati ERROR 404
    { path: '**', title:'404 Page not found', component: PageNotFoundComponent }
];

RouterModule.forRoot(routes);